import * as yup from 'yup';

const calculatorSchema = yup
  .object({
    state: yup
      .string()
      .required('Provide this field'),
    livingRoom: yup
      .string()
      .required('Provide this field'),
    bedRoom: yup
      .string()
      .required('Confirm this field'),
    kitchen: yup
      .string()
      .required('Provide this field'),
    toiletBath: yup
      .string()
      .required('Confirm this field'),
    type: yup
      .string()
      .required('Confirm this field'),
  })
  .required();

export { calculatorSchema };
